import { useState, useEffect } from "react";
import { useWindowSize } from "./useWindowSize";

export const DelayRender = ({ children, delay = 0 }) => {
  const [isShown, setIsShown] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setIsShown(true);
    }, delay);
  }, [delay]);

  return isShown ? children : null;
};

export const useMargins = () => {
  const { horizontal, w, h } = useWindowSize();
  const screenMenuVerticalPadding = horizontal ? w(2) : h(3);
  const screenMenuHorizontalPadding = horizontal ? w(2) : h(3);
  // for lines and content alignment in screens
  const screenContentVerticalPadding = horizontal ? h(5) : w(9);
  const screenContentHorizontalPadding = horizontal ? h(5) : w(9);
  return {
    screenMenuVerticalPadding,
    screenMenuHorizontalPadding,
    screenContentVerticalPadding,
    screenContentHorizontalPadding,
  };
};
